export default "<div class=\"alert alert-danger alert-dismissible custom-err-class\" >\n  {{inputerrormsg}}\n</div>";